"use strict";

var AccountStore = require("./AccountStore");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");

var Spinner = require("../client/Spinner");

var WizardConstants = require("../constants/WizardConstants");

var ApiHelper = require("../shared/ApiHelper");
var InputHelper = require("../shared/InputHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var reportsComponentSelector = "[data-component='reports']";
var reportSelectSelector = "[data-component='reports.selector.select']";
var reportParametersComponentSelector = "[data-component='reports.parameters']";
var reportButtonSelector = "[data-component='reports.button']";
var dateSelector = "[data-component='reports.parameters.date.input']";
var decimalNumberSelector = "[data-component='reports.parameters.decimalNumber.input']";
var wholeNumberSelector = "[data-component='reports.parameters.wholeNumber.input']";

var ReportsHelper = {
	initialize: function (options) {
		options = options || {};

		if (options.isDesignMode || $(reportsComponentSelector).length === 0) {
			return;
		}

		$(reportButtonSelector).on("click.downloadReport", this.downloadReport.bind(this));
		$(reportSelectSelector).on("change.selectReport", this.loadReportParameters.bind(this));

		$(reportSelectSelector).each((index, element) => {
			var $selector = $(element);

			$selector.closest(reportsComponentSelector)
				.find(reportParametersComponentSelector)
				.hide();

			// Trigger the initial parameters refresh if a report is initially selected.
			if ($selector.val()) {
				$selector.trigger("change.selectReport");
			}
		});

		// Store the date format on each report component so we can re-initialize inputs upon reloading parameter partials.
		var $reportsComponent = $(reportsComponentSelector);
		var dateFormat = (options.wizardDateFormat && options.wizardDateFormat.dateFormat) || {};
		$reportsComponent.attr("data-date-format", JSON.stringify(dateFormat));

		this._initializeInputs($reportsComponent);
	},

	_initializeInputs: function ($reportsComponent) {
		this._initializeDates($reportsComponent);
		this._initializeWholeNumbers($reportsComponent);
		this._initializeDecimalNumbers($reportsComponent);
	},

	_initializeWholeNumbers: function ($reportsComponent) {
		var $component = $reportsComponent.find(wholeNumberSelector);

		InputHelper.initializeIntegerInput({
			$component,
			defaultValue: null,
			greaterThanZero: false,
			numberSelector: $component,
			allowNegative: true
		});
	},

	_initializeDecimalNumbers: function ($reportsComponent) {
		var $component = $reportsComponent.find(decimalNumberSelector);

		InputHelper.initializeDecimalInput(
			/*$component:*/ $component,
			/*amountSelector:*/ $component,
			/*greaterThanZero:*/ false,
			/*formatAmount:*/ false,
			/*defaultValue:*/ null,
			/*includeThousandsSeparator:*/ false,
			/*allowNegative:*/ true
		);
	},

	_initializeDates: function ($reportsComponent) {
		var dateFormat = JSON.parse($reportsComponent.attr("data-date-format"));

		InputHelper.initializeDates({
			$component: $reportsComponent,
			dateSelector,
			wizardDateFormat: dateFormat
		});

		//Adding custom validator for Date fields for when submit is clicked
		$reportsComponent.find(dateSelector).each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({
				customValidator: () => {
					var errorMessages = [];
					var date = $element.val();

					if (date != null && date != "") {
						errorMessages = InputHelper.validateDates({
							dateFormat: dateFormat,
							date,
							dateInvalidMessage: window.FORM_VALIDATION_MESSAGES.INVALID_DATE,
						}) || [];
					}

					return {
						errorMessages,
						isValid: !errorMessages.length
					};
				}
			});
		});
	},

	downloadReport: function (event) {
		try {
			event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("reportsDownload"));

			if (!event) {
				return false;
			}

			event.preventDefault();

			var $reportsComponent = $(event.target).closest(reportsComponentSelector);

			Spinner.showSpinner($reportsComponent);

			var components = [
				$reportsComponent
			];

			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner($reportsComponent);
					return;
				}

				var report = this.serializeReport($reportsComponent);

				AccountApi.downloadReport(report, AccountStore.get("shouldOpenReportsInNewTab")).fail((statusCode) => {
					var wizardName = WizardConstants.WIZARDS.REPORT_DISPLAY_MESSAGES;
					var wizardFields = WizardConstants.REPORT_DISPLAY_MESSAGES_FIELDS;

					var message = statusCode === 409 ?
						AccountStore.getWizardValue(wizardName, wizardFields.REPORT_CONFIGURATION_CHANGED) :
						AccountStore.getWizardValue(wizardName, wizardFields.DOWNLOAD_ERROR);

					BootstrapPrompt.alert(message);
				}).always(() => {
					Spinner.removeSpinner($reportsComponent);
				});
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			Spinner.removeSpinner($reportsComponent);
		} finally {
			return false;
		}
	},

	loadReportParameters: function (event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("reportsLoadPartial"));
		if (!event) {
			return false;
		}

		event.preventDefault();
		var $reportsComponent = $(event.target).closest(reportsComponentSelector);
		var $reportParametersComponent = $reportsComponent.find(reportParametersComponentSelector);
		var reportId = event.target && event.target.value || "";

		var options = {
			reportId,
			reportParametersComponentId: $reportParametersComponent.attr("id")
		};

		this._loadReportParameters($reportsComponent, options);

		return false;
	},

	_loadReportParameters: function ($reportsComponent, options) {
		options = options || {};

		Spinner.showSpinner($reportsComponent);
		AccountApi.getReportParameters(options).done((data) => {
			var $partial = $(data);
			if (!options.reportId) {
				$partial.hide();
			}

			$reportsComponent.find(reportParametersComponentSelector).replaceWith($partial);
			this._initializeInputs($reportsComponent);
			Spinner.removeSpinner($reportsComponent);
		}).fail((jqXHR) => {
			jqXHR = jqXHR || {};
			if (jqXHR.status == 400) {
				if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
					//There was not a partial error, so do what we normally would do.
					ApiHelper.displayErrorMessage(jqXHR);
				}
			}

			Spinner.removeSpinner($reportsComponent);
		});
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage);
	},

	serializeReport: function ($reportsComponent) {
		var $reportsSelectorComponent = $reportsComponent.find(reportSelectSelector);
		var $reportsParametersComponent = $reportsComponent.find(reportParametersComponentSelector);
		var $parameterComponents = $reportsParametersComponent.find("input,select");

		var report = {
			reportId: $reportsSelectorComponent.val()
		};

		$parameterComponents.each((index, element) => {
			var $element = $(element);

			var parameterName = $element.attr("name");
			var parameterValue = $element.val();

			report[parameterName] = parameterValue;
		});

		return report;
	}
};

module.exports = ReportsHelper;
